import { gql } from '@apollo/client';

export const SEND_CONFIRM_EMAIL = gql`
    mutation SendConfirmEmail($id: ID!) {
        sendConfirmEmail(id: $id) {
            id
        }
    }
`;
